var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.855.474c-4.561 0-9.123.026-13.685 0-.98 0-1.778.8-1.778 1.778.025 3.84.025 7.68 0 11.521 0 .98.799 1.804 1.778 1.778 2.268-.025 4.536 0 6.804 0h6.881c1.083 0 1.753-.67 1.753-1.752V2.252c0-1.108-.67-1.778-1.753-1.778zM8.227 8.567v5.051c0 .232-.052.31-.31.31H2.35c-.283 0-.36-.103-.36-.361V3.438c0-.206.077-.258.283-.258h5.644c.232 0 .31.078.31.31v5.077zm7.783 4.974c0 .284-.077.361-.36.361h-5.594c-.257 0-.257-.103-.257-.31V8.516 3.438c0-.232.051-.31.283-.31h5.619c.232 0 .31.052.31.31a659.388 659.388 0 000 10.103z",
    fill: "currentColor"
  })));
}

export default SvgOverview;